module.exports = __webpack_public_path__ + "static/media/icons_Bilan bless‚ m‚dullaire.0fa2180a.svg";